import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11d32184"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "images"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showImagesCarousel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.product.imagesUrl[_ctx.currentSlide].url,
          class: "image-inner",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openImageModal(_ctx.currentSlide)), ["prevent"])),
          alt: "Imagem do produto"
        }, null, 8, _hoisted_2)
      ]))
    : _createCommentVNode("", true)
}